import { Box3, Box3Helper, Group } from 'three';
import { ProjectRenderer } from '../ProjectRenderer';
import { RotationDirection } from '@/types/types';
import { SerializedDraggableObject, ThreeEvent } from '../types';
import RENDERER_CONFIG from '@/configs/rendererConfig';

const { DRAGGABLE_OBJECT } = RENDERER_CONFIG;

export abstract class DraggableObject {
	static readonly ROTATION_SNAP = DRAGGABLE_OBJECT.ROTATION_SNAP;

	id = crypto.randomUUID();
	protected _isDragging = false;
	protected _isMouseOver = false;

	box = new Box3();
	protected boxHelper = new Box3Helper(this.box, 0xff0000);

	group = new Group();
	level = 0;

	constructor(protected renderer: ProjectRenderer) {}

	get isMouseOver() {
		return this._isMouseOver;
	}

	set isMouseOver(value: boolean) {
		if (value)
			this.renderer.emitter.emit(ThreeEvent.MOUSE_OVER_MODULE, this.id);

		if (this._isMouseOver === value) return;
		this._isMouseOver = value;
	}

	get isDragging() {
		return this._isDragging;
	}

	set isDragging(value: boolean) {
		if (this._isDragging === value) return;
		this._isDragging = value;
	}

	protected loadFromData<T extends SerializedDraggableObject>(data: T) {
		this.group.position.set(...data.position);
		this.group.rotation.y = data.rotation;
	}

	protected updateBox() {
		this.box.setFromObject(this.group);
	}

	rotate(direction: RotationDirection) {
		if (direction === RotationDirection.CLOCKWISE)
			this.group.rotateY(-DraggableObject.ROTATION_SNAP);
		else this.group.rotateY(DraggableObject.ROTATION_SNAP);

		this.updateBox();
	}
}
